import { render, staticRenderFns } from "./CampaignPreOrdersTab.vue?vue&type=template&id=42f04906&scoped=true&"
import script from "./CampaignPreOrdersTab.vue?vue&type=script&lang=js&"
export * from "./CampaignPreOrdersTab.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPreOrdersTab.vue?vue&type=style&index=0&id=42f04906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f04906",
  null
  
)

export default component.exports